import { render } from "./SavingsPlanCard.vue?vue&type=template&id=08744832&scoped=true"
import script from "./SavingsPlanCard.vue?vue&type=script&lang=js"
export * from "./SavingsPlanCard.vue?vue&type=script&lang=js"

import "./SavingsPlanCard.vue?vue&type=style&index=0&id=08744832&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08744832"

export default script